import Vue from 'vue'

import FooterNav from './components/FooterNav.vue'
import PrimaryNav from './components/PrimaryNav.vue'

Vue.prototype.$theme = 'default'

Vue.component('FooterNav', FooterNav)
Vue.component('PrimaryNav', PrimaryNav)
